//@ts-check

class BalanceSheetDataService {
	constructor($sce, $http, Utility, $timeout, $rootScope, ContentService, LocalStorageService, InternalLinksService) {
		this.$sce = $sce;
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;
		this.init();
	}

	init() {
		this.balanceSheetData = undefined;
	}

	/**
	 * @param {string} schemeRef
	 * @param {Date} date
	 */
	async getBalanceSheet(schemeRef, date) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('FinancialApiBalanceSheet');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiBalanceSheet');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();
			const headers = this.Utility.headersWithContentType;

			if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
				const error = `Could not load Balance Sheet as the 'Username' and/or 'Session Token' is missing`;
				this.$timeout(() => promiseHandler.reject(error));
			}

			const results = await this.$http.post(url, date, { headers });
			const { data } = results;
			this.balanceSheetData = data;
			this.$timeout(() => promiseHandler.resolve());
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}
}

export default /* @ngInject */ (
	$sce,
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	LocalStorageService,
	InternalLinksService
) =>
	new BalanceSheetDataService(
		$sce,
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		LocalStorageService,
		InternalLinksService
	);
